import ParserBase from "./parser-base";
import ValueMapper from "../common/value-mapper";

/**
 * 使用海水の受信情報を表示データに変換する
 */
class SeaWater extends ParserBase {
  /**
   * 殺菌装置の情報を表示データに変換する
   */
  parseSterilizer(sterilizer) {
    const chlorine = ValueMapper.join([
      { value: "塩素", condition: sterilizer.chlorine },
    ]).present(
      (value) =>
        value +
        "（" +
        ValueMapper.sum([sterilizer.chlorine_concentration], "-1").getOrElse(
          "-"
        ) +
        "ppm）"
    );
    const uv = ValueMapper.join([
      { value: "紫外線", condition: sterilizer.uv },
    ]).present(
      (value) =>
        value +
        "（" +
        ValueMapper.map({
          0: "不適",
          1: "適",
        }).getOrElse(sterilizer.uv_status, "-") +
        "）"
    );
    return ValueMapper.join([chlorine, uv], "<br />").getOrElse("-");
  }

  /**
   * 受信したHACCP情報を表示データに変換する
   * @param {受信したHACCP情報} data
   * @returns 表示データ
   */
  contentsParse(data) {
    return [
      {
        title: "ろ過器の管理",
        message: ValueMapper.join(
          [
            { value: "逆洗", condition: data.filter_maintenance.backwash },
            { value: "ろ材補充", condition: data.filter_maintenance.supply },
            { value: "ろ材交換", condition: data.filter_maintenance.exchange },
          ],
          "<br />"
        ).getOrElse("なし"),
      },
      {
        title: "殺菌装置",
        message: this.parseSterilizer(data.sterilizer),
      },
      {
        title: "冷却海水温度",
        message:
          ValueMapper.sum([data.water_temperature], 9999).getOrElse("-") + `℃`,
      },
      {
        title: "塩分濃度",
        message: `${data.salinity}％`,
      },
    ];
  }
}

export default new SeaWater({
  type: "object",
  properties: {
    type: { type: "string", enum: ["SEAWATER"] },
    date: { type: "string", format: "date" },
    filter_maintenance: {
      type: "object",
      properties: {
        backwash: { type: "boolean" },
        supply: { type: "boolean" },
        exchange: { type: "boolean" },
      },
      required: ["backwash", "supply", "exchange"],
    },
    sterilizer: {
      type: "object",
      properties: {
        chlorine: { type: "boolean" },
        chlorine_concentration: { type: "number" },
        uv: { type: "boolean" },
        uv_status: { type: "integer", enum: [-1, 0, 1] },
      },
      required: ["chlorine", "chlorine_concentration", "uv", "uv_status"],
    },
    water_temperature: { type: "number" },
    salinity: { type: "number" },
  },
  required: [
    "type",
    "date",
    "filter_maintenance",
    "sterilizer",
    "water_temperature",
    "salinity",
  ],
});
